export default __webpack_public_path__ + "static/media/Good team-rafiki 5.a9bb4138.png";